import React from 'react';
import MainMenuItem from './MainMenuItem';
import cssModules from '@/core/assets/scss/components/Dashboard/MainMenu.module.scss';
import MainMenuParentItem from './MainMenuParentItem';
import {
  businessAccountCompanySubroutes,
  businessAccountTeamSubroutes,
} from '@/core/pages/BusinessAccounts/routerConfig';
import { t } from '@lingui/core/macro';
import useFeatureCheck from '@/core/features/auth/hooks/useFeatureCheck';
import { TenantFeatures } from '@/features/auth/enums';

const MainMenu = () => {
  const hasFeature = useFeatureCheck();

  return (
    <nav className={cssModules['main-navigation']}>
      <ul>
        {hasFeature(TenantFeatures.BOOKING_HUB) && (
          <MainMenuItem
            to="/business-account/trips"
            content={t({ id: 'general.mainMenu.bookings', message: 'Pre-booked trips' })}
            icon="calendar"
          />
        )}
        {hasFeature(TenantFeatures.ON_DEMAND) && (
          <MainMenuItem
            to="/business-account/on-demand-trips"
            content={t({ id: 'general.mainMenu.onDemand', message: 'On-demand trips' })}
            icon="trips"
          />
        )}

        <MainMenuParentItem
          path="/business-account/team"
          content={t({ id: 'general.mainMenu.team', message: 'Team' })}
          icon="users"
          subRoutes={businessAccountTeamSubroutes}
        />

        <MainMenuItem
          to="/business-account/cost-centers"
          content={t({ id: 'general.mainMenu.costCenters', message: 'Cost centers' })}
          icon="chartAscending"
        />

        <MainMenuParentItem
          path="/business-account/company"
          content={t({ id: 'general.mainMenu.company', message: 'Company' })}
          icon="buildings"
          subRoutes={businessAccountCompanySubroutes}
        />
      </ul>
    </nav>
  );
};

export default MainMenu;
